<template>
    <div class="vehicle-view-page page pb-3 py-2" style="max-width: 900px">
        <div class="row">
            <div class="col-sm-12">
                <div class="page-title-box">
                    <h4 class="page-title" id="page_title">Vehicle Details</h4>
                </div>
            </div>
        </div>
        <div class="card card-body">
            <div v-if="!vehicle && loading">Loading...</div>
            <div v-if="!vehicle && !loading">Vehicle is unavailable</div>
            <div v-if="isSold">Unauthorized Page</div>
            <div v-if="vehicle && !isSold">
                <div class="d-flex justify-content-between pb-3">
                    <h3 class="card-title font-16 m-0 align-self-center">
                        {{ vehicle.formattedFullVehicleName }}
                    </h3>
                    <div class="d-flex align-items-center">
                        <star-vehicle :vehicle="vehicle"/>
                    </div>
                </div>
                <div class="row inner-container m-0">
                    <div class="col-lg-4 col-12 pb-3 p-0">
                        <div class="pb-lg-5">
                            <div class="py-2">
                                <label>Price: </label>
                                <span>{{ vehicle.price | currency }}</span>
                                <span
                                    class="d-block"
                                    style="font-size: 11px; margin-top: -6px;"
                                    >
                                    (Dealer may add additional fees)
                                </span>
                            </div>
                            <div class="py-2">
                                <label>Mileage: </label>
                                <span>{{ vehicle.mileage | local_number }}</span>
                            </div>
                            <div class="py-2">
                                <label>Body: </label>
                                <span>{{ data_get(vehicle, 'body.name') }}</span>
                            </div>
                            <div class="py-2">
                                <label>Condition: </label>
                                <span>{{ data_get(vehicle, 'condition.name') }}</span>
                            </div>
                            <div class="py-2">
                                <label>Color: </label>
                                <span>{{ data_get(vehicle, 'color.name') }}</span>
                            </div>
                            <div class="py-2">
                                <label>Foundri ID: </label>
                                <span>FND-{{ vehicle.id }}</span>
                            </div>
                            <div class="py-2">
                                <label>VIN: </label>
                                <span>{{ vehicle.vin }}</span>
                            </div>
                            <div class="py-2">
                                <label>Status: </label>
                                <span>
                                    <i :class="[vehicleStatusClass]"
                                       class="mdi mdi-checkbox-blank-circle"/>
                                    {{ vehicleStatusLabel }}
                                </span>
                            </div>
                            <div class="mb-2" v-if="vehicle.company.is_wholesale">
                                <span class="badge badge-secondary">Wholesale</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-8 col-12 p-0 images-container">
                        <image-swiper
                            :images="car_images_urls"
                            v-if="vehicle"
                        />
                    </div>
                </div>
                <div>
                    <div class="row mt-3 mt-sm-0">
                        <div class="col-sm-12 px-2">
                            <div class="position-relative mt-3">
                                <div v-if="vehicle.dealership_details" class="py-2">
                                    <h5 class="font-18 mb-3">Dealership Info</h5>
                                    <div class="row mb-3">
                                        <div class="col-md-6 col-12">
                                            <div><label>Name: </label> <span>{{ vehicle.dealership_details.name }}</span>
                                            </div>
                                            <div><label>Address: </label> <span>{{
                                                    vehicle.dealership_details.address
                                                }}</span></div>
                                            <div v-if="vehicle.dealership_details.address2"><label>Address 2: </label>
                                                <span>{{
                                                        vehicle.dealership_details.address2
                                                    }}</span></div>
                                        </div>
                                        <div class="col-md-6 col-12">
                                            <div><label>City: </label> <span>{{ vehicle.dealership_details.city }}</span>
                                            </div>
                                            <div><label>Zip Code: </label> <span>{{
                                                    vehicle.dealership_details.zip_code
                                                }}</span></div>
                                            <div><label>State: </label> <span>{{ vehicle.dealership_details.state }}</span>
                                            </div>
                                            <div v-if="vehicle.dealership_details.url"><label>Url: </label>
                                                <span>{{ vehicle.dealership_details.url }}</span>
                                            </div>
                                            <div v-if="vehicle.dealership_details.fax"><label>Fax: </label>
                                                <span>{{ vehicle.dealership_details.fax }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class=" mt-2 mb-3">
                                    <button
                                        v-if="canViewContactDetailsButton"
                                        class="btn btn-dark"
                                        type="button"
                                        @click="$refs.companyEnquiryModal.show()"
                                        >
                                        <ContactDetailsIcon class="pr-1" />
                                        Contact Details
                                    </button>
                                    <hr class="hr hr-blurry" />
                                </div>
                            </div>
                            <div class="form-group mb-3">
                                <div v-if="vehicle.provider ===  'home net'">
                                    <div class="d-flex justify-content-between">
                                        <h5 class="font-18">Options </h5>
                                        <span class="toggle-options d-flex align-items-center font-weight-bold" @click="showOptions = !showOptions">
                                            {{showOptions ? 'Show Less' : 'Show More'}} <i :class="showOptions ? 'mdi mdi-chevron-up' : 'mdi mdi-chevron-down'"/>
                                        </span>
                                    </div>
                                    <div v-show="showOptions">
                                        <div>
                                            <div
                                                v-if="vehicle && vehicle.additional_information && vehicle.additional_information.length"
                                                class="row">
                                                <div v-for="item in vehicle.additional_information"
                                                     class="custom-control custom-checkbox col-md-3 col-12 px-2">
                                                <span>
                                                    <i class="mdi mdi-checkbox-marked-circle info-check-icon"/>
                                                    {{ item.name }}
                                                </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <h5 class="font-18 mb-3">Additional Information </h5>
                                    <div>
                                        <div>
                                            <div
                                                v-if="vehicle && vehicle.additional_information && vehicle.additional_information.length"
                                                class="row">
                                                <div v-for="item in vehicle.additional_information"
                                                     v-if="item.meta && item.meta.availability === InfoAvailabilities.standard"
                                                     class="custom-control custom-checkbox col-md-3 col-12 px-2">
                                                <span>
                                                    <i class="mdi mdi-checkbox-marked-circle info-check-icon"/>
                                                    {{ item.name }}
                                                </span>
                                                </div>
                                            </div>
                                            <div class="row external-details mt-3">
                                                <div v-for="(external_vehicle_detail, index) in ExternalVehicleDetails"
                                                     v-if="vehicle.detail"
                                                     class="custom-control custom-checkbox col-md-3 col-12 px-2">
                                                    <div>
                                                    <span class="bold">
                                                        {{ external_vehicle_detail.label }}:&nbsp;
                                                    </span>
                                                        {{ vehicle.detail[index] }}
                                                    </div>
                                                </div>
                                                <div class="custom-control custom-checkbox col-md-3 col-12 px-2">
                                                    <div>
                                                    <span class="bold">
                                                        Maximum Towing:&nbsp;
                                                        {{
                                                            getExternalVehicleMaxTowing(vehicle.additional_information)
                                                                ? getExternalVehicleMaxTowing(vehicle.additional_information)
                                                                : 'N/A'
                                                        }}
                                                    </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12 px-2 px-sm-3">
                            <div v-if="vehicle.additional_features" class="form-group">
                                <label class="col-form-label">Additional Features / Accessories: </label>
                                <textarea :rows="4"
                                          class="form-control"
                                          readonly
                                          title="additional features"
                                          type="text"
                                          v-model="vehicle.additional_features"/>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="px-2 px-sm-3" :class="vehicle.physical_transfer_info ? 'col-sm-6' : 'col-sm-12'">
                            <div v-if="vehicle.deal_conditions" class="form-group">
                                <label class="col-form-label">Deal Conditions:</label>
                                <div>
                            <textarea :rows="4"
                                      class="form-control"
                                      title="deal conditions'"
                                      readonly
                                      type="text"
                                      v-model="vehicle.deal_conditions"/>
                                </div>
                            </div>
                        </div>
                        <div class="px-2 px-sm-3" :class="vehicle.deal_conditions ? 'col-sm-6' : 'col-sm-12'">
                            <div v-if="vehicle.physical_transfer_info" class="form-group">
                                <label class="col-form-label">Physical Transfer Info:</label>
                                <div>
                            <textarea :rows="4"
                                      class="form-control"
                                      title="physical transfer info'"
                                      readonly
                                      type="text"
                                      v-model="vehicle.physical_transfer_info"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="d-sm-flex justify-content-between">
                        <div>
                            <button @click="createDeal()"
                                    class="btn btn-primary waves-effect waves-light"
                                    type="button"
                                    v-if="shouldShowDealButton()">
                                <i class="mdi mdi-handshake"/>
                                Deal
                            </button>
                            <button @click="share"
                                    class="btn btn-primary waves-effect waves-light"
                                    type="button"
                                    v-if="hasRole([Roles.dealer_principle, Roles.sales_manager])">
                                <i class="mdi mdi-send"/>
                                Send to
                            </button>
                            <button @click="backToResults"
                                    class="btn btn-secondary waves-effect waves-light"
                                    type="button">
                                <i class="mdi mdi-car"/>
                                Back to Results
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <share-modal
            v-if="vehicle"
            ref="shareModal"
            :vehicle="vehicle"
            @success="onSuccessShare"
            />
        <company-enquiry-modal
            v-if="vehicle"
            ref="companyEnquiryModal"
            :vehicle="vehicle"
        />
    </div>
</template>

<script>
import ImageSwiper from "@/components/custom/ImageSwiper";
import StarVehicle from "@/components/main/StarVehicle";
import ShareModal from "@/components/main/vehicle/ShareModal";
import InfoAvailabilities from "@/constants/info-availabilities";
import Roles from "@/constants/roles";
import Routes from "@/constants/routes";
import ExternalVehicleDetails from "@/constants/vehicle/external_vehicle_details";
import vehicle_mixin from "@/mixins/vehicle"
import Vehicle from "@/models/vehicle";
import VehicleUtils from "@/utils/vehicle";
import VehicleStatus from "@/constants/vehicle-statuses";
import ContactDetailsIcon from "@/components/main/icons/ContactDetailsIcon";
import CompanyEnquiryModal from "@/components/main/company/CompanyEnquiryModal";

export default {
    mixins: [
        vehicle_mixin
    ],
    components: {
        ImageSwiper,
        StarVehicle,
        ShareModal,
        ContactDetailsIcon,
        CompanyEnquiryModal,
    },
    data() {
        return {
            VehicleStatus,
            InfoAvailabilities,
            ExternalVehicleDetails,
            Roles,
            vehicle: null,
            car_images_urls: [],
            loading: false,
            hide_listing: false,
            showOptions: false,
            enquiry_handlers: [],
        }
    },
    created() {
        this.initVehicle();
    },
    computed: {
        user() {
            return this.$store.state.user;
        },
        isSold() {
            if (!this.vehicle) {
                return false
            }
            return this.vehicle.status === VehicleStatus.sold.value
        },
        canViewContactDetailsButton() {
            const isVehicleOwnedByCurrentCompany = this.vehicle.company_id === this.$store.state.user.companies[0].id;

            return !!(this.hasRole([Roles.dealer_principle, Roles.sales_manager]) && !isVehicleOwnedByCurrentCompany);
        },
    },
    methods: {
        initVehicle() {
            this.loading = true;
            Vehicle
                .include(
                    'vehicleMake',
                    'transmission',
                    'body',
                    'condition',
                    'color',
                    'fuelType',
                    'numberOfDoors',
                    'drive',
                    'media',
                    'detail',
                    'additionalInformation',
                    'images',
                    'company',
                    'dealershipDetails',
                    'deals.buyer.companies',
                    'deals.seller.companies',
                )
                .params({
                    add_view: 1
                })
                .find(this.$route.params.id)
                .then((response) => {
                    this.vehicle = response;
                    this.hide_listing = !!this.vehicle.hid_at;
                    VehicleUtils.arrangeVehicleImages(this.vehicle.images);
                    this.car_images_urls = _.map(this.vehicle.images, (image) => {
                        return image.url;
                    })
                    this.initEnquiryHandlers(this.vehicle);
                })
                .finally(() => {
                    this.loading = false;
                })
        },
        viewVehicle() {
            this.$router.push({
                name: Routes.view_vehicle,
                params: {
                    id: this.vehicle.id
                }
            })
        },
        backToResults() {
            if (this.$route.query.back) {
                return this.$router.push(this.$route.query.back);
            }
            return this.$router.push({
                name: Routes.vehicle
            });
        },
        createDeal() {
            this.$router.push({
                name: Routes.create_deal,
                params: {
                    vehicle_id: this.vehicle.id
                }
            });
        },
        shouldShowDealButton() {
            const isVehicleOwnedByCurrentCompany = this.vehicle.company_id !== this.$store.state.user.companies[0].id;

            if (!this.hasRole([Roles.sales_person]) && isVehicleOwnedByCurrentCompany) {
                if (!this.vehicle?.deals?.find(deal => deal.buyer?.companies[0].id === this.$store.state.user.companies[0].id) && isVehicleOwnedByCurrentCompany) {
                    return true;
                }

                return this.vehicle.deals.find(deal => deal.buyer?.companies[0].id === this.$store.state.user.companies[0].id);
            } else {
                if (!this.vehicle?.deals?.find(deal => deal.buyer?.companies[0].id === this.$store.state.user.companies[0].id) && isVehicleOwnedByCurrentCompany) {
                    return true;
                }
            }

            return this.vehicle.deals.find(deal => deal.buyer_id === this.$store.state.user.id)
        },
        share() {
            this.$refs.shareModal.show();
        },
        onSuccessShare(share) {
            this.$refs.shareModal.hide();
        },
        initEnquiryHandlers(vehicle) {
            return axios.post('/web-api/user/dealer-enquiry-handler?include=roles', {
                    company_id: vehicle.company_id,
                })
                .then((response) => {
                    this.enquiry_handlers = response.data;
                })
        },
    }
}
</script>

<style scoped>
.actions-container {
    margin-bottom: -6px;
    position: absolute;
    bottom: 16px;
}
.toggle-options{
    color: #59bdd3;
    cursor: pointer;
}
</style>
